/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};


(function () {
  'use strict';

  /**
   * Хелпер для форматирования чисел.
   * @type {{formatNumber: Function}}
   */
  app.helpers.NumberHelper = {
    /**
     * Возвращает целое отформатированное число с указанной разрядностью.
     * @param {number} value Передаваемое значение.
     * @param {number} size Необходимая разрядность числа.
     * @returns {string} Отформатированное число.
     */
    digitsNumber: function (value, size) {
      var s = String(value);

      if (typeof size !== 'number') {
        size = 2;
      }
      while (s.length < size) {
        s = '0' + s;
      }
      return s;
    },

    /**
     * Возвращает целое отформатированное цисло с указанной разрядностью в виде массива.
     * @param {number} value Передаваемое значение.
     * @param {number} size Необходимая разрядность числа.
     * @returns {Array} Отформатированное число.
     */
    digitsNumberArray: function (value, size) {
      var s = this.digitsNumber(value, size);
      return s.split('');
    },

    /**
     * Метод для округления числа до двух знаков при операциях c числами с плавающей запятой (в частности ценами).
     * @param value
     * @returns {number}
     */
    roundFloatPointNum: function (value) {
      var result;
      if (value < 0.01 && value > 0) {
        result = Math.round(value * 10000) / 10000;
      } else {
        result = Math.round(value * 100) / 100;
      }
      return result;
    },

    /**
     * Функция для разделения числа на целую и дробную части.
     * @param {string|number} value Значение для приведения к стоимости.
     * @param {string} [separator] Разделитель в числах больше 3-х знаков.
     * @returns {Array} Массив с целой и дробной частями (или пустой, если не удалось привести значение к числу).
     */
    fractionNumber: function (value, separator) {
      separator = String(separator) === separator ? separator : ' ';
      var string = String(value).toLowerCase(),
        number = Number(string),
        result = [],
        decimals;
      if (!isNaN(number)) {
        decimals = (number < 0.01 && number > 0) ? 4 : 2;
        result = [
          number.toFixed(2).replace(/\.[^.]*$/g, ''), // убираем все числа после точки и точку
          number.toFixed(decimals).replace(/^.*\./g, ''), // убираем все числа до точки и точку
        ];
        var array = result[0].split(''), // получаем массив строк с цифрами из строки целой части числа
          separated = [];
        while (array.length) {
          separated.unshift(array.splice(-3).join('')); // вытаскиваем последние три цифры и объединяем в строку
        }
        result[0] = separated.join(separator); // подменяем целую часть на целую разделённую
      }
      return result;
    },

    /**
     * Метод разделяет числа на целую и дробную части через fractionNumber,
     * после проверяет на '00' дробную часть c последующей очисткой строки, если условие выполняется.
     * @param {string|number} value Значение для приведения к стоимости.
     * @param {string} [separator] Разделитель в числах больше 3-х знаков.
     * @returns {Array} Массив с целой и дробной частями
     * или пустой, если не удалось привести значение к числу,
     * или с одним элементом целой части, если дробная равна '00'
     */
    numberWithoutZeroFraction: function (value, separator) {
      var result = this.fractionNumber(value, separator);
      if (app.hasPricesWithoutZeroPenny && result[1] === '00') {
        result.pop();
      }
      return result;
    },

    /**
     * Добавляет пробел к целому или дробному числу.
     * @param value
     * @return {string}
     */
    addSpaceToFloatNumber: function (value) {
      var numberArray = this.fractionNumber(value),
        result;
        if (Number(numberArray[1].slice(0, 1)) > 0) {
          result = numberArray[0] + '.' + numberArray[1].slice(0, 1);
        } else {
          result = numberArray[0];
        }
        return result;
    },

    /* выпилить */
    fractionPrice: function () {
      return this.fractionNumber.apply(null, arguments);
    },
    formatNumberInt: function () {
      return this.fractionNumber.apply(null, arguments)[0];
    },
    formatNumber: function () {
      return this.fractionNumber.apply(null, arguments).join('.');
    }
    /* выпилить */

  };
})();

}.call(window));